enum FusePanel
{
	Old = 1,
	New = 2
}

export default FusePanel;